import type { AreaCatalog } from '../area';
import type { checklist as en } from '../en/checklist';

export const checklist = {
  'checklist.line.move': '„{title}“ verschieben',
  'checklist.tick.done': 'Fertig: „{title}“',
  'checklist.tick.undo': 'Rückgängig: „{title}“',
  'checklist.tick.undoCancelled': 'Rückgängig: „{title}“ (abgebrochen)',
  'checklist.tick.accept': 'Annehmen: „{title}“',
  'checklist.inReview': 'in Review',
  'checklist.waits.review': 'wartet auf die Review',
  'checklist.waits.names': 'wartet auf {names}',
  'checklist.waits.requester': 'wartet auf die Verantwortlichen',
  'checklist.closedBy': 'von {name}',
  'checklist.locked.title': 'Nur ansehen. Tippe, um die Verantwortlichen zu fragen',
  'checklist.locked.label': 'Die Verantwortlichen bitten, „{title}“ abzuschließen',
  'checklist.retry': 'Nicht gespeichert. Erneut versuchen',
  'checklist.hashtag.list': 'Tags',
  'checklist.digest': '{done} von {total}',
  'checklist.digestLabel': '{done} von {total} erledigt',
  'checklist.expand': 'Die Liste von „{title}“ zeigen',
  'checklist.collapse': 'Die Liste von „{title}“ ausblenden',
  'checklist.lineTick.done': '„{text}“ abhaken',
  'checklist.lineTick.undo': 'Haken bei „{text}“ entfernen',
  'checklist.lineLocked': 'Nur ansehen: „{text}“',
  'checklist.lineMenu.label': 'Punkt „{text}“',
  'checklist.lineMenu.edit': 'Bearbeiten',
  'checklist.lineMenu.promote': 'Zur Unteraufgabe machen',
  'checklist.lineMenu.indent': 'Unter den Punkt darüber',
  'checklist.lineMenu.outdent': 'Eine Ebene höher',
  'checklist.lineMenu.remove': 'Entfernen',
  'checklist.lineEdit.label': '„{text}“ bearbeiten',
  'checklist.promoteOpen': 'Alle offenen Punkte zu Unteraufgaben machen',
  'checklist.itemMenu.label': 'Unteraufgabe „{title}“',
  'checklist.itemMenu.demote': 'Zum Punkt machen',
  'checklist.itemMenu.open': 'Öffnen',
  'checklist.addLine': 'Punkt hinzufügen',
} as const satisfies AreaCatalog<typeof en>;
